import { render, staticRenderFns } from "./ElFeaturedPostTitle.vue?vue&type=template&id=2a8f70aa"
import script from "./ElFeaturedPostTitle.vue?vue&type=script&lang=js"
export * from "./ElFeaturedPostTitle.vue?vue&type=script&lang=js"
import style0 from "./ElFeaturedPostTitle.vue?vue&type=style&index=0&id=2a8f70aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports